var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVoiceTel01 = function SvgIconVoiceTel01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 37.9,
    y1: 69.25,
    x2: 124.74,
    y2: 58.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 37.74,
    y1: 67.94,
    x2: 124.59,
    y2: 57.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 38.06,
    y1: 70.57,
    x2: 124.9,
    y2: 60.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 35.4,
    y1: 48.65,
    x2: 122.24,
    y2: 38.12,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.88,84.24c-.75,0-1.5-.29-2.07-.86-1.14-1.14-1.14-3,0-4.14,7.78-7.78,7.78-20.43,0-28.2-1.14-1.14-1.14-3,0-4.14,1.14-1.14,3-1.14,4.14,0,10.06,10.06,10.06,26.43,0,36.49-.57.57-1.32.86-2.07.86h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.89,75.2c-.75,0-1.5-.29-2.07-.86-1.14-1.14-1.14-3,0-4.14,2.79-2.79,2.79-7.34,0-10.13-1.14-1.14-1.14-3,0-4.14s3-1.14,4.14,0c5.08,5.08,5.08,13.34,0,18.41-.57.57-1.32.86-2.07.86h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.83,92.17c-1.14-1.14-1.14-3,0-4.14,12.62-12.62,12.62-33.16,0-45.78-1.14-1.14-1.14-3,0-4.14,1.14-1.14,3-1.14,4.14,0,14.91,14.91,14.91,39.16,0,54.07-.57.57-1.32.86-2.07.86s-1.5-.29-2.07-.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.78,100c-.4,0-.81-.08-1.2-.26-1.47-.67-2.13-2.4-1.46-3.88l3.95-8.75c1.58-3.49,5.07-5.7,8.9-5.64,5.15.09,11.47.19,14.63.12.77-.02,1.8-.17,2.38-.83.57-.64.57-1.6.52-2.12-.38-3.83,1.28-5.94,2.28-7.19.14-.17.29-.37.42-.54l-7.07-4.45c-1.58-.99-2.44-2.76-2.26-4.62.18-1.86,1.38-3.42,3.13-4.08l9.89-3.75-1.02-5.36c-.42-2.19.06-4.4,1.36-6.22s3.22-3,5.43-3.32l4.32-.63-10.28-17.46c-2.35-4-3.28-8.72-2.62-13.31l.76-5.21c.23-1.6,1.72-2.71,3.32-2.48s2.71,1.72,2.48,3.32l-.76,5.21c-.48,3.27.19,6.65,1.87,9.5l11.04,18.74c.82,1.4.9,3.1.2,4.56-.7,1.46-2.07,2.47-3.68,2.71l-5.79.85c-.61.09-1.15.42-1.51.92-.36.51-.49,1.12-.38,1.73l1.14,5.97c.44,2.29-.73,4.58-2.83,5.59-.07.03-.15.07-.22.09l-8.8,3.34,5.89,3.7c.09.05.17.11.25.17,1.78,1.39,2.57,3.61,2.03,5.64-.36,1.34-1.1,2.28-1.7,3.03-.79,1-1.19,1.5-1.04,2.97.25,2.54-.44,4.88-1.96,6.59-1.1,1.24-3.14,2.73-6.65,2.8-3.26.06-9.65-.03-14.85-.12-1.48-.03-2.85.83-3.46,2.19l-3.95,8.75c-.49,1.08-1.56,1.72-2.67,1.72h0ZM33.06,63.26h0,0Z"
  })));
};
export default SvgIconVoiceTel01;